// *******************************************************************************
// Close Modal When Escape Key Press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.e-publication-modal').forEach((el) => {
      modalBox.classList.remove('is-open-modal');
    });
  }
});

let cropper;

attachEvent('.mod-file-upload__list-edit', 'click', (ev) => {
  const parentModal = ev.target.closest('.mod-file-upload');
  const cropModal = parentModal.querySelector('.crop-intra-image-modal');
  if (cropModal) {
    cropModal.classList.add('is-open-modal');
    const image = cropModal.querySelector('.crop-intra-image-modal__image');
    if (image) {
      const fileUploaderNew = document.querySelector('.mod-file-upload__input');
      const [files] = fileUploaderNew.files;
      if (files) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(files);
        fileReader.addEventListener('load', (e) => {
          image.src = e.currentTarget.result;
          const saveBtn = cropModal.querySelector('#crop');
          const minCroppedWidth = 200;
          const minCroppedHeight = 200;
          const maxCroppedWidth = 200;
          const maxCroppedHeight = 200;
          cropper = new Cropper(image, {
            aspectRatio: 1,
            zoomable: false,
            viewMode: 1,
            data: {
              width: (minCroppedWidth + maxCroppedWidth) / 2,
              height: (minCroppedHeight + maxCroppedHeight) / 2
            },

            crop(event) {
              const { width } = 100;
              const { height } = 100;

              if (
                width < minCroppedWidth
                || height < minCroppedHeight
                || width > maxCroppedWidth
                || height > maxCroppedHeight
              ) {
                cropper.setData({
                  width: 100,
                  height: 100
                });
              }
            }
          });
        });
      }


    }
  }
  ev.preventDefault();
});

attachEvent('.crop-intra-image-modal__close,.crop-intra-image-modal__cancel', 'click', (ev) => {
  ev.preventDefault();
  const parentModal = ev.target.closest('.crop-intra-image-modal');
  parentModal.classList.remove('is-open-modal');
  if (cropper) {
    cropper.destroy();
    cropper = null;
  }
});

attachEvent('.crop-intra-image-modal__save', 'click', (ev) => {
  const parentModal = ev.target.closest('.mod-file-upload');
  const cropModal = parentModal.querySelector('.crop-intra-image-modal');
  if (cropModal) {
    if (cropper) {
      const image = cropModal.querySelector('.crop-intra-image-modal__image');
      if (image) {
        const fileUploaderNew = document.querySelector('.mod-file-upload__input');
        const files = fileUploaderNew.files[0];
        if (files) {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(files);
          fileReader.addEventListener('load', (e) => {
            const canvas = cropper.getCroppedCanvas();
            parentModal.querySelector('.mod-file-upload__icon').innerHTML = `<img src='${canvas.toDataURL()}'  alt='user-avatar'/>`;
            parentModal.querySelector('#croped-file-data').value = canvas.toDataURL();
            cropper.destroy();
            cropper = null;
          });
        }
      }
    }
    cropModal.classList.remove('is-open-modal');
  }
  ev.preventDefault();
});




